import { PageLayout } from '@/layouts/PageLayout'
import TeamSection from '@/layouts/TeamSection'
import JobBoardSection from '@/layouts/JobBoardSection'
import LandingSection from '@/layouts/LandingSection'
import LocationSection from '@/layouts/LocationSection'
import PartnersSection from '@/layouts/PartnersSection'
import SessionsSection from '@/layouts/SessionsSection'
import SpeakersSection from '@/layouts/SpeakersSection'

import { partnersData } from '@/data/2025/partners'
import { SpeakersData as Speakers2025 } from '@/data/2025/speakers'
import { teamData } from '@/data/2025/team'

function Home() {
  return (
    <PageLayout>
      <h1 id="main-heading" className="sr-only">
        Michigan DevFest 2025
      </h1>
      <LandingSection />
      <LocationSection />
      <SessionsSection
        year={2025}
        speakersData={Speakers2025}
        tracks={[
          'Schedule',
          'Map',
          'Hackathon',
          'Build with AI',
          'Tech+Design',
          'Level Up',
          'Leadership',
          'Innovation',
          'Workshops',
        ]}
        defaultExpanded
      />
      <SpeakersSection
        year={2025}
        speakersData={Speakers2025}
        defaultExpanded
      />
      <JobBoardSection year={2025} />
      <PartnersSection year={2025} partnersData={partnersData} />
      <TeamSection year={2025} teamData={teamData} />
    </PageLayout>
  )
}

export default Home
